import React from 'react';
import { Redirect } from 'react-router-dom';

const NotFoundPage = () => <Redirect to="/" />;

export default NotFoundPage;
